module.exports = __webpack_public_path__ + "img/ofr-ltr-issued.14c7f1ec.svg";